.jb-notification-wrapper-web-component{
    position: var(--position);
    box-sizing: border-box;
    overflow: var(--overflow);
    display: var(--display);
    align-items: var(--align-items);
    flex-direction: var(--flex-direction);
    gap: var(--gap);
    width: var(--width);
    height: var(--height);
    padding-top: var(--padding-top);
    z-index: var(--z-index);
    top: var(--top);
    left: var(--left);
    pointer-events: var(--pointer-events);
}
